module.exports = __webpack_public_path__ + "img/tcs_logo_2x.png";